<app-kakaotalk-template-preview [templateDisplayedBS]="templateDisplayedBS"> </app-kakaotalk-template-preview>
